export const cheatsheetsHubPage = () =>
  import("./CheatsheetsHubPage").then((m) => ({ Component: m.CheatsheetsHubPage }));
